<template>
  <div v-if="aDuContenu" class="contact-support">
    <div v-if="instructions && support.paiementInstructions" class="mb-2">
      <div class="fw-semibold mb-1"><i class="bi bi-cash-coin me-1"></i>Comment payer</div>
      <div class="instructions">{{ support.paiementInstructions }}</div>
    </div>
    <div v-if="aDesContacts">
      <div v-if="titre" class="fw-semibold mb-1"><i class="bi bi-headset me-1"></i>{{ titre }}</div>
      <div class="d-flex flex-wrap gap-2" :class="{ 'justify-content-center': centre }">
        <a v-if="support.telephone" :href="'tel:' + nettoyer(support.telephone)" class="btn btn-sm" :class="clair ? 'btn-light' : 'btn-outline-primary'">
          <i class="bi bi-telephone me-1"></i>{{ support.telephone }}
        </a>
        <a v-if="support.whatsapp" :href="lienWhatsapp" target="_blank" rel="noopener" class="btn btn-sm" :class="clair ? 'btn-light' : 'btn-outline-success'">
          <i class="bi bi-whatsapp me-1"></i>WhatsApp
        </a>
        <a v-if="support.email" :href="lienEmail" class="btn btn-sm" :class="clair ? 'btn-light' : 'btn-outline-secondary'">
          <i class="bi bi-envelope me-1"></i>{{ support.email }}
        </a>
      </div>
      <small v-if="support.horaires" class="d-block mt-1" :class="clair ? 'text-white-50' : 'text-muted'"><i class="bi bi-clock me-1"></i>{{ support.horaires }}</small>
    </div>
  </div>
</template>

<script>
/** Coordonnées du support de la plateforme (réglées dans Plateforme → Paramètres). */
export default {
  name: 'ContactSupport',
  props: {
    support: { type: Object, default: () => ({}) },
    titre: { type: String, default: 'Contacter le support' },
    sujet: { type: String, default: '' },
    message: { type: String, default: '' },
    instructions: { type: Boolean, default: false },
    centre: { type: Boolean, default: false },
    clair: { type: Boolean, default: false }
  },
  computed: {
    aDesContacts() {
      const s = this.support || {}
      return !!(s.telephone || s.whatsapp || s.email)
    },
    aDuContenu() {
      return this.aDesContacts || (this.instructions && this.support?.paiementInstructions)
    },
    lienWhatsapp() {
      const numero = String(this.support.whatsapp || '').replace(/[^0-9]/g, '')
      return 'https://wa.me/' + numero + (this.message ? '?text=' + encodeURIComponent(this.message) : '')
    },
    lienEmail() {
      const params = []
      if (this.sujet) params.push('subject=' + encodeURIComponent(this.sujet))
      if (this.message) params.push('body=' + encodeURIComponent(this.message))
      return 'mailto:' + this.support.email + (params.length ? '?' + params.join('&') : '')
    }
  },
  methods: {
    nettoyer(t) {
      return String(t).replace(/[^0-9+]/g, '')
    }
  }
}
</script>

<style scoped>
.instructions { white-space: pre-line; background: #fffbea; border: 1px solid #f5e3a3; border-radius: 8px; padding: 8px 12px; font-size: .9rem; }
</style>
